import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { CircledIconModule } from '@stantec/basin/circled-icon'
import { AccordionModule } from 'primeng/accordion'
import { ButtonModule } from 'primeng/button'
import { DividerModule } from 'primeng/divider'
import { DropdownModule } from 'primeng/dropdown'
import { MenuModule } from 'primeng/menu'
import { NavmenuComponent } from './navmenu.component'
import { NavmenuStantecLogoComponent } from './navmenu-stantec-logo'
import { NavmenuStantecIconComponent } from './navmenu-stantec-icon'

@NgModule({
  declarations: [
    NavmenuComponent,
    NavmenuStantecLogoComponent,
    NavmenuStantecIconComponent,
  ],
  imports: [
    AccordionModule,
    CommonModule,
    ButtonModule,
    CircledIconModule,
    MenuModule,
    DividerModule,
    FormsModule,
    DropdownModule,
  ],
  exports: [NavmenuComponent],
})
export class NavmenuModule {}
